import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { actions as formActions } from "reducers/form";
import { transactionStatus } from "pages/transactions/constants";

export const useIsSignerPending = (idTransaction) => {
    const dispatch = useDispatch();
    const { transaction } = useSelector((state) => state.form);
    const { user } = useSelector((state) => state.session);

    useEffect(() => {
        if (idTransaction) {
            dispatch(formActions.readAgreementTransaction(idTransaction));
        }
    }, [idTransaction, dispatch]);

    const isSignerPending = useMemo(
        () =>
            isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
            transaction?.idTransactionStatus === transactionStatus.PENDING,
        [transaction, user],
    );
    return {
        isSignerPending,
    };
};

export default useIsSignerPending;
